import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import { useSearchParams } from 'react-router-dom';
import ManagerTimesheet from './manager-timesheet';
import EmployeeManagerTimesheet from './employee-manager-timesheet';
// import { timesheetApi } from '../../services';
import './style.scss';
const Timesheets = () => {
    const user = useSelector(selectUser);
    const [isEmployeeDashboard, setDashboard] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [query, setQuery] = useState({});
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const empIndex = user.roles.indexOf('employee')
        setDashboard(empIndex !== -1);
        const param = { empId: searchParams.get('ecn'), action: searchParams.get('action') };
        setQuery(param);
        localStorage.setItem('param', JSON.stringify(param));
    }, []);



    return (<div className='timesheet-wrapper'>
        {isEmployeeDashboard ? <><EmployeeManagerTimesheet query={query} /></> : <><ManagerTimesheet query={query} /></>}
    </div>)
}

export default Timesheets;